export let navigationPaneLabel = "mctUFe";
export default {navigationPaneLabel};